import DOMPurify from "dompurify";

function SafeHtml({ html, dir, className }) {
  const clean = DOMPurify.sanitize(html ?? "", { USE_PROFILES: { html: true } });
  return <div dir={dir} className={className} dangerouslySetInnerHTML={{ __html: clean }} />;
}

const GAP_SIZE = { sm: 10, md: 20, lg: 32 };

export default function PaperBlocks({ blocks = [] }) {
  return (
    <div className="space-y-1.5 text-foreground">
      {blocks.map((block) => {
        const dir = block.direction === "rtl" ? "rtl" : "ltr";

        if (block.type === "hr") {
          return <hr key={block.id} className="border-border my-3" />;
        }

        if (block.type === "gap") {
          return <div key={block.id} style={{ height: GAP_SIZE[block.size] ?? 16 }} />;
        }

        if (block.type === "table") {
          return (
            <table key={block.id} dir={dir} className="w-full border-collapse my-2">
              <tbody>
                {(block.rows ?? []).map((row, ri) => (
                  <tr key={ri}>
                    {row.map((cell, ci) => (
                      <td key={ci} className={block.showBorder ? "border border-border p-2 align-top" : "p-2 align-top"}>
                        <SafeHtml html={cell} dir={dir} />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          );
        }

        return <SafeHtml key={block.id} html={block.content} dir={dir} />;
      })}
    </div>
  );
}
